import utils from 'blue-utils';
import publicState from '$config/store/state';

//扩展公共的state
const state = utils.extend(publicState, {
  /*项目相关的state*/
  view: {
    tabBar: 'home'
  },
  userInfo: {},
  
  /*需要缓存的页面*/
  catchPages: ["home"],
  
  /*申请直播流程中选择的资讯*/
  selectInfo:[],
  /*申请直播流程中选择的商品*/
  selectGoods:[],

//  选择地址
  selectAddressValue:{
    allSelect:{}, //地址所有信息
    addressName:'', //地址字符串
    bulidName:'', //建筑物名称
    location:''
  },
  shareState:false
});

export default state;
